export function fmtCurrency(value: number, currency = 'USD', maxFrac = 2): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: maxFrac }).format(value)
}

export function fmtNumber(value: number, maxFrac = 2): string {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: maxFrac }).format(value)
}

export function fmtPct(value: number, frac = 1): string {
  return `${(value * 100).toFixed(frac)}%`
}

export function fmtPctValue(value: number, frac = 1): string {
  return `${value.toFixed(frac)}%`
}

export function fmtSigned(value: number, frac = 2): string {
  const s = value.toFixed(frac)
  return value > 0 ? `+${s}` : s
}

export function fmtSignedCurrency(value: number, currency = 'USD'): string {
  const formatted = fmtCurrency(Math.abs(value), currency)
  return value < 0 ? `-${formatted}` : `+${formatted}`
}

export function fmtCents(cents: number): string {
  return `${cents}\u00A2`
}

export function fmtDate(iso: string): string {
  return iso.slice(0, 10)
}

export function pnlClass(value: number): string {
  if (value > 0) return 'pos'
  if (value < 0) return 'neg'
  return 'muted'
}

export function clampInput(value: string, min: number, max: number, fallback: number): number {
  const n = Number(value)
  if (!Number.isFinite(n)) return fallback
  return Math.max(min, Math.min(max, n))
}
